import { AuthErrorKind } from '@griply/types';
import { getAuthErrorMessageKey } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppleButton } from './apple-button';
import { GoogleButton } from './google-button';
import * as Styled from './third-party-signup-buttons.style';

export type ThirdPartySignupButtonsProps = {
  isLoading?: boolean;
  error?: AuthErrorKind;
  onAppleLogin: () => void;
  onGoogleLogin: () => void;
};

export const ThirdPartySignupButtons: React.FC<
  ThirdPartySignupButtonsProps
> = ({ isLoading, error, onAppleLogin, onGoogleLogin }) => {
  const { t } = useTranslation();
  const errorMessageKey = error ? getAuthErrorMessageKey(error) : null;

  return (
    <>
      <Styled.List>
        <Styled.ListItem>
          <AppleButton isLoading={isLoading} onClick={onAppleLogin} />
        </Styled.ListItem>
        <Styled.ListItem>
          <GoogleButton isLoading={isLoading} onClick={onGoogleLogin} />
        </Styled.ListItem>
      </Styled.List>
      {!!errorMessageKey && (
        <Styled.ErrorMessage role="alert">
          {t(errorMessageKey)}
        </Styled.ErrorMessage>
      )}
    </>
  );
};
